import { z } from 'zod'
import { MESSAGES } from '../utils/messages'

// `required_error`/`invalid_type_error` cubren el caso `undefined` (campo nunca
// tocado): sin ellos Zod emite el default en inglés ("Required"). El `.min(1)`
// cubre el string vacío. Así el mensaje siempre es el español de MESSAGES.
export const requiredString = (msg: string = MESSAGES.REQUIRED) =>
  z.string({ required_error: msg, invalid_type_error: msg }).min(1, msg)

/**
 * Campo de texto opcional. Acepta `undefined`, `null` o cadena (incluida la vacía)
 * y normaliza `null` → `undefined`. El `null` es habitual cuando el dato viene de
 * Mongo (campos con `default: null`) o de JSON; el boundary de validación lo tolera
 * para no romper el submit. El tipo de salida sigue siendo `string | undefined`.
 */
export const optionalString = () =>
  z
    .string()
    .nullish()
    .transform((value) => value ?? undefined)

export const email = (msg: string = MESSAGES.EMAIL) => z.string().email(msg)
